import { render, staticRenderFns } from "./ResponsibleChoiceWidgetComponent.vue?vue&type=template&id=1e382c74&"
import script from "./ResponsibleChoiceWidgetComponent.vue?vue&type=script&lang=js&"
export * from "./ResponsibleChoiceWidgetComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports